// src/components/Hero.js
import React from 'react';

const Hero = () => {
    return (
        <section id="home" className="section-content">
            <div className="hero">
                <h1>Deep Parmar</h1>
                <p>Computer Science Student at <a className="pdisc" href="https://www.uregina.ca/"> University of Regina </a></p>
            </div>
        </section>
    );
};

export default Hero;
